import { render, staticRenderFns } from "./RewardsLinks.vue?vue&type=template&id=7d5d8570&scoped=true&"
import script from "./RewardsLinks.vue?vue&type=script&lang=js&"
export * from "./RewardsLinks.vue?vue&type=script&lang=js&"
import style0 from "./RewardsLinks.vue?vue&type=style&index=0&id=7d5d8570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5d8570",
  null
  
)

export default component.exports